/**
 * Однократный reload при падении dynamic import — защита от version skew:
 * после деплоя открытая страница может запросить ленивый чанк, которого на
 * сервере уже нет (хэш сменился). Reload уводит навигацию в свежий precache/билд.
 * Guard в sessionStorage не даёт зациклиться (второй провал = честная ошибка,
 * например реальный оффлайн без кеша).
 */
const RELOAD_GUARD_KEY = 'chunk-reloaded'

export async function importChunk<T>(load: () => Promise<T>): Promise<T> {
  try {
    const mod = await load()
    sessionStorage.removeItem(RELOAD_GUARD_KEY)
    return mod
  } catch (error) {
    if (sessionStorage.getItem(RELOAD_GUARD_KEY) === '1') throw error
    sessionStorage.setItem(RELOAD_GUARD_KEY, '1')
    location.reload()
    // Страница уходит в перезагрузку — промис намеренно не резолвится.
    return new Promise<never>(() => undefined)
  }
}
